export default __webpack_public_path__ + "static/play-store-0e13f731203545e53849d85a05681b92.png";